import { render, staticRenderFns } from "./avalonSideBar.vue?vue&type=template&id=0808f058&scoped=true&"
import script from "./avalonSideBar.vue?vue&type=script&lang=js&"
export * from "./avalonSideBar.vue?vue&type=script&lang=js&"
import style0 from "./avalonSideBar.vue?vue&type=style&index=0&id=0808f058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808f058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSheet})
